// extracted by mini-css-extract-plugin
export default {"card-container":"style_card-container__jpb7F","desc":"style_desc__9oLSq","control":"style_control__U2lVw","label":"style_label__YZQrA","radio":"style_radio__3GTIb"};